import classNames from 'classnames';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

export default function Card({ children, className, ...restProps }: CardProps) {
	return (
		<div className={classNames('fh-card', className)} {...restProps}>
			{children}
		</div>
	);
}
